import { render } from "./MaintenanceScreen.vue?vue&type=template&id=27e4b018&scoped=true&ts=true"
import script from "./MaintenanceScreen.vue?vue&type=script&lang=ts"
export * from "./MaintenanceScreen.vue?vue&type=script&lang=ts"

import "./MaintenanceScreen.vue?vue&type=style&index=0&id=27e4b018&lang=scss&scoped=true"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e4b018"]])

export default __exports__